(function () {
    'use strict';

    angular.module('ib-pmt-app', [
        'pascalprecht.translate',
        'ib-pmt-module',
        'ib-pmt-order-confirmation-module',
        'ib-pmt-communication-lost-module',
        'ib-check-in-confirmation-module',
        'ib-pmt-injectable-module',
        'ib-pmt-gift-cards-confirmation-module',
        'ib-pmt-subscription-models-confirmation-module',
        'ib-reusable-module',
        'ib-ng-react-component-module'
    ]);
})();
